import { useContext, useEffect } from 'react';
import Select from 'components/ui-components/Select';
import { PostcodeSelectorContext } from '../PostcodeSelectorProvider';
import { setSelectedAddress } from '../postcodeSelectorStateManager';
import {
  findSelectedAddress,
  resetFieldValidationAndErrors,
} from '../postcodeSelectorUtils';
import { addressSelectionRequired } from '../errorMessages';

const AddressSelector = () => {
  const {
    id,
    dispatch,
    fetchedAddresses,
    addressList,
    setValue,
    errors,
    setError,
    clearErrors,
  } = useContext(PostcodeSelectorContext);

  const selectPlaceholder = 'Select your address';

  const resetField = resetFieldValidationAndErrors(setValue, clearErrors);

  useEffect(() => {
    resetField(`${id}AddressSelector`, `${id}AddressSelectorValid`, false);
  }, []);

  const disableFields = () => {
    resetField(`${id}AddressSelector`, `${id}AddressSelectorValid`);
    resetField(`${id}Number`, `${id}NumberValid`);
    resetField(`${id}Line1`, `${id}Line1Valid`);
    resetField(`${id}Line4`, `${id}Line4Valid`);
    resetField(`${id}Postcode`, `${id}PostcodeValid`);
  };

  const handleAddressSelect = event => {
    const value = event.target.value;

    if (value === selectPlaceholder) {
      setError(`${id}AddressSelector`, {
        type: 'required',
        message: addressSelectionRequired,
      });

      dispatch(setSelectedAddress(null));
    } else {
      disableFields();

      const selectedAddressObject = findSelectedAddress(
        id,
        value,
        fetchedAddresses,
        selectPlaceholder,
      );

      dispatch(setSelectedAddress(selectedAddressObject));
    }
  };

  return (
    <Select
      className="mt-20"
      id={`${id}AddressSelector`}
      label="Select an Address"
      placeholder={selectPlaceholder}
      selectItems={addressList}
      onChange={handleAddressSelect}
      errors={errors && errors[`${id}AddressSelector`] ? errors : null}
    />
  );
};

export default AddressSelector;
